<template>
    <b-row
        id="slider"
        v-touch:swipe="onSwipe"
        tabindex="-1"
        @keydown.left="$emit('prev')"
        @keydown.right="$emit('next')"
    >
        <b-col
            offset-xl="1"
            class="slider-wrapper py-4"
            order-lg="1"
        >
            <div class="d-flex px-4">
                <div 
                    v-for="(s, i) in stories"
                    :key="i"
                    ref="cards"
                    class="slider-card cursor-pointer mx-2"
                    :class="{'active': i === currentId}"
                    @click="$emit('selected', i)"
                >
                    <story-author
                        :author="s.author"
                        class="author-sm mb-2"
                    />

                    <p class="small text-danger mb-2">
                        <fa
                            icon="quote-right"
                            size="xs"
                        />
                    </p>

                    <p class="small">
                        {{ $t(s.title) }}
                    </p>
                </div>
            </div>
        </b-col>
        
        <b-col
            lg="3"
            xl="2"
            class="m-4 intro"
        >
            <h4 class="d-none d-lg-block mb-3">
                {{ $t('home.slider.title') }}
            </h4>

            <p class="d-none d-lg-block small">
                {{ $t('home.slider.text') }}
            </p>

            <div class="arrow-buttons">
                <btn-arrow
                    left 
                    :disabled="currentId == 0"
                    @click="$emit('prev')"
                />

                <btn-arrow
                    class="ml-2"
                    :disabled="currentId == stories.length - 1"
                    @click="$emit('next')"
                />
            </div>
        </b-col>
    </b-row>
</template>

<script>
import BtnArrow from '@/components/common/BtnArrow';
import StoryAuthor from '@/components/common/StoryAuthor';

export default {
    name: 'Slider',
    components: { StoryAuthor, BtnArrow },
    props: {
        stories: {
            type: Array,
            default: () => [],
        },
        currentId: {
            type: Number,
            default: 0,
        },
    },
    mounted() {
        // Scroll to correct card when user picks different one.
        // Add watcher when mounted because `$refs` is not yet available before.
        this.$watch('currentId',
            function(id) {
                // Bug: scrollIntoView doesn't happen if the y position is
                // unchanged. To fix this, we programmatically scroll the window
                // by 1px before calling scrollIntoView. 
                window.scrollBy(0, 1);

                this.$refs['cards'][id].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center',
                });
            },
        );
    },
    methods: {
        onSwipe(direction) {
            if (direction === 'left') {
                this.$emit('next');
            } else if (direction === 'right') {
                this.$emit('prev');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#slider {
    background-color: #dfebed;
}

.slider-wrapper {
    display: flex;
    overflow-x: hidden;
}

.slider-card {
    display: inline-block;
    min-width: 11.5rem;
    padding: .8rem 1.9rem;
    text-align: center;
    background-color: #f2f7f7;

    &:hover {
        background-color: $white;
    }

    &.active {
        background-color: $white;
        box-shadow: $box-shadow-lg;
        transform: translateY(-1rem);
    }
}

.arrow-buttons {
    position: absolute;
    bottom: 0;

    @include media-breakpoint-down(md) {
        right: 0;
        left: 0;
        text-align: center;
    }
}
</style>